// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12.3027 8.24609L15.333 5.19141L23.4082 13.333L18.3633 18.4199L15.333 15.3643L12.3027 18.4199L8.66601 14.7529L5.63672 17.8086L0.591797 12.7227L8.66699 4.58008L12.3027 8.24609ZM13.0117 10.3701L13.0127 10.3711L10.0742 13.333L12.3027 15.5791L15.333 12.5244L18.3633 15.5791L20.5908 13.333L15.333 8.03125L13.0117 10.3701ZM3.4082 12.7217L5.63574 14.9678L10.8945 9.66602L8.66601 7.41992L3.4082 12.7217Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-tencentmeeting')
export default class LogoTencentmeetingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-tencentmeeting',
    }
  }
}
